import { FieldArray, useFormikContext } from 'formik';
import { useParams, Link,createSearchParams  } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Form, Input as AntInput, Button as AntButton, Select, Modal, Table, Tooltip, message ,Upload} from 'antd';
import { useOrderBeltSave, useOrderBeltUpdate } from 'store/server/useOrder';
import DisliSayisiDetayModal from 'components/form/modals/DisliSayisiDetayModal';
import { Input as FormikInput } from 'components/form/input';
import { Input as UIInput } from 'components/ui/input';
import { Button as UIButton } from 'components/ui/button';
import { toast } from 'components/ui/use-toast';
import BeltSizes from '../BeltInstructions/BeltSize';
import { RotateCcw, X } from 'lucide-react';
import { RxCross1 } from "react-icons/rx";
import { SelectReferanceCode4 } from 'components/form/compobox/select-referance-code4';
import { SelectReferanceCode4Home } from 'components/form/compobox/select-referance-code4home';
import requests from 'service/api';
import { useAuth } from 'store/client/authStore'
import { Button } from 'components/ui/button'
import BeltSizesHome from '../BeltInstructions/BeltSize/indexhome';
const { Option } = Select;

export default function BeltInstructions({ currentTab,brannd }) {
  const { values, setFieldValue } = useFormikContext();
  const { mutate: saveOrder, isPending } = useOrderBeltSave();
  const { mutate: updateOrder, isPending: isPendingUpdate } = useOrderBeltUpdate();
  const { brand, orderNo, dept, subDept } = useParams();
  const [isDisliModalVisible, setIsDisliModalVisible] = useState(false)
  const brandId = brand.split('_')[0];
  const fieldArrayPushRef = useRef(null);
  const hasInitializedBeltLabel = useRef(false);
  const { user } = useAuth()
  const [valcx, setvalcx] = useState(false);
  const [sizeAmounts, setSizeAmounts] = useState({})
  const [totalAmount, setTotalAmount] = useState(0)
    const [isBicakIziModalVisible, setIsBicakIziModalVisible] = useState(false)

    const [departmantIDD, setdepartmantIDD] = useState('')
    const [ifinch,setifinch] = useState(false)

console.log("values.beltLabel",values.beltLabel);
  const DrawerContent4 = () => {
    const [form4] = Form.useForm();
    const [isUploading, setIsUploading] = useState(false);
    const [uploadError, setUploadError] = useState(null);

    const handleFileUpload = async (values) => {
      const formData = new FormData();
      
      // Dosya kontrolü
      if (!values.file || values.file.length === 0) {
        message.error('Lütfen bir PDF dosyası seçin');
        return;
      }

      const file = values.file[0].originFileObj;
      const fileName = values.fileName;
      
      if (!fileName) {
        message.error('Lütfen bir dosya adı girin');
        return;
      }

      formData.append('file', file);
      formData.append('type', 'belt');
      formData.append('name', fileName);

      setIsUploading(true);
      setUploadError(null);

      try {
        const response = await requests.order.convertPdfToSvg(formData);
        
        if (response.status === 200) {
          message.success('PDF başarıyla SVG\'ye dönüştürüldü');
          setvalcx(!valcx)
          form4.resetFields();
          setIsDisliModalVisible(false)
        }
      } catch (error) {
        console.error('Hata:', error);
        setUploadError('Dosya yüklenirken bir hata oluştu');
        message.error('Dosya yüklenirken bir hata oluştu');
      } finally {
        setIsUploading(false);
      }
    };

    return (
      <div>
        <Form
          form={form4}
          layout="vertical"
          onFinish={handleFileUpload}
        >
          <Form.Item
            label="Referans Kodu"
            name="fileName"
            rules={[{ required: true, message: 'Lütfen bir referans kodu girin' }]}
          >
            <AntInput 
              placeholder="Referans Kodu girin"
              style={{ width: '100%' }}
            />
          </Form.Item>

          <Form.Item
            label="PDF Dosyası"
            name="file"
            rules={[{ required: true, message: 'Lütfen bir PDF dosyası seçin' }]}
            valuePropName="fileList"
            getValueFromEvent={(e) => {
              if (Array.isArray(e)) {
                return e;
              }
              return e && e.fileList;
            }}
          >
            <Upload
              beforeUpload={(file) => {
                // Dosya tipini kontrol et
                const isPDF = file.type === 'application/pdf';
                if (!isPDF) {
                  message.error('Sadece PDF dosyaları yükleyebilirsiniz!');
                  return Upload.LIST_IGNORE;
                }
                return false;
              }}
              accept=".pdf"
              maxCount={1}
              listType="text"
            >
              <AntButton>PDF Seç</AntButton>
            </Upload>
          </Form.Item>

          <Form.Item>
            <AntButton
              type="primary"
              htmlType="submit"
              loading={isUploading}
              style={{ width: '100%' }}
            >
              {isUploading ? 'Yükleniyor...' : 'Referans Kodu Ekle'}
            </AntButton>
          </Form.Item>

          {uploadError && (
            <div style={{ color: 'red', marginTop: '10px' }}>
              {uploadError}
            </div>
          )}
        </Form>
      </div>
    );
  };


  const handleBicakIziModalOpen = () => {
    // Tüm bedenler için sıfırlama işlemi
    const initialSizeAmounts = {};
    
    // Sadece seçilmiş bedenleri göster (adet değeri girilmiş olanlar)
    const selectedSizes = values.beltLabel[0]?.sizes.filter(size => 
      size.amount && size.amount !== '0' && size.amount !== 0
    );
    
    console.log("selectedSizes",selectedSizes);
    // Her beden için değeri açıkça 0 olarak ayarla
    selectedSizes.forEach(size => {
      console.log("selecteddddsize",size);
      // Beden kodu+beden adı birleşik key oluşturuyoruz
      const key = `${size.sCode}_${size.name || 'Beden'}`;
      initialSizeAmounts[key] = 0;
    });
    
    // State'i güncelle
    setSizeAmounts(initialSizeAmounts);
    setTotalAmount(0);
    setIsBicakIziModalVisible(true);
  
  };
  
  const handleBicakIziModalClose = () => {
    setIsBicakIziModalVisible(false)
  }
  
  const handleSizeAmountChange = (sizeCode, sizeName, value) => {
    // Birleşik key oluştur
    const key = `${sizeCode}_${sizeName || 'Beden'}`;
    
    // Girilen değeri sayıya çevir (boş ise 0)
    const numValue = value === '' ? 0 : parseInt(value, 10);
    
    // Diğer tüm bedenlerin toplamını hesapla
    let otherSizesTotal = 0;
    Object.entries(sizeAmounts).forEach(([existingKey, amount]) => {
      if (existingKey !== key) {
        otherSizesTotal += amount;
      }
    });
    
    // Toplam adet kontrolü
    if (otherSizesTotal + numValue > 27) {
      // 20'yi aşıyorsa, maksimum izin verilen değeri hesapla
      const maxAllowed = 27 - otherSizesTotal;
      
      // Eğer maksimum değer 0'dan küçükse, hiç değer girilmesine izin verme
      if (maxAllowed <= 0) {
        toast.error("Toplam adet 20'yi geçemez!");                              
        return;
      }
      
      // Değeri güncelle - Sadece ilgili beden key'i değişecek
      const updatedAmounts = { ...sizeAmounts };
      updatedAmounts[key] = maxAllowed;
      setSizeAmounts(updatedAmounts);
      
      // Yeni toplam
      const newTotal = Object.values(updatedAmounts).reduce((sum, val) => sum + val, 0);
      setTotalAmount(newTotal);
      return;
    }
    
    // Normal durumda değeri güncelle - Sadece ilgili beden key'i değişecek
    const updatedAmounts = { ...sizeAmounts };
    updatedAmounts[key] = numValue;
    setSizeAmounts(updatedAmounts);
    
    // Yeni toplam
    const newTotal = Object.values(updatedAmounts).reduce((sum, val) => sum + val, 0);
    setTotalAmount(newTotal);
  };
  const handleBicakIziBas = () => {
    // İşlem tamamlandıktan sonra modalı kapat
    setIsBicakIziModalVisible(false)
    // Başarılı mesajı göster
    toast.success('Bıçak izi hazırlama işlemi başarıyla tamamlandı')
  }
  
    const createBicakIziUrl = () => {
    // Temel URL ve tab parametresi
    let url = `/siparisler/artwork/${orderNo}?tab=3&gottype=man`;
    if(brannd === "ZaraHome"){
      url = `/siparisler/artwork/${orderNo}?tab=3&gottype=man&zaratype=ZaraHome`;
    }

    // Beden ve adet bilgilerini ekle
    let paramIndex = 0;
    
    // Size mappings oluştur (sizeCode => {sizeName, count})
    const sizeMappings = {};
    
    // Önce tüm size code ve name eşleşmelerini al
    values.beltLabel[0]?.sizes
    .filter(size => size.amount && size.amount !== '0' && size.amount !== 0)
    .forEach(size => {
      const sizeName =  size.name || size.sizeCode;
      const key = `${size.sCode}_${sizeName}`;
      console.log("key",key);
      console.log("sizeAmounts[key]",sizeAmounts);
      if (sizeAmounts[key] > 0) {
        sizeMappings[paramIndex] = {
          sizeCode: size.sCode,
          sizeName: sizeName,
          count: sizeAmounts[key]
        };
        paramIndex++;
      }
    });
  
    
    // URL parametrelerini ekle
    // URL parametrelerini ekle
    Object.entries(sizeMappings).forEach(([index, sizeInfo]) => {
      url += `&sizecode${index}=${encodeURIComponent(sizeInfo.sizeCode)}`;
      url += `&sizename${index}=${encodeURIComponent(sizeInfo.sizeName)}`;
      url += `&count${index}=${sizeInfo.count}`;
    });
    
    // Toplam parametre sayısını da ekle
    url += `&totalParams=${paramIndex}`;
    console.log("url",url);
    return url;
  };



  const handleSaveOrder = () => {
    const errors = []
    const filteredValuesxx = values.beltLabel.map((label) => {
      if(!label.colorCode || !label.referanceCode)
      {
        errors.push("Renk Kodu ve Referans Kodu Girilmek Zorunda")
      }
      return label
    })
    const department = `${brand.split('_')[1]} / ${dept.split('_')[1]} / ${subDept}`;
    const filteredValues = values.washingLabel.map(label => {
      const filteredFabric = label.fabric.map(fabricItem => {
        const filteredMix = fabricItem.mix.filter(mix => mix.percent > 0);
        return { ...fabricItem, mix: filteredMix };
      });
      return { ...label, fabric: filteredFabric };
    });

    const path = `${brand}/${dept}/${subDept}`;
    if(errors.length > 0) {
      toast.error(errors.join('\n'))
      return; // İşlemi durdurur
    }
    if(errors.length === 0)
    {
      saveOrder({ ...values, washingLabel: filteredValues, brand: brandId, department, path });
    }
  };
  const handleDisliModalClose = () => {
    setIsDisliModalVisible(false)
  }


  const handleDisliModalOpen = () => {
    setIsDisliModalVisible(true)
  }
  const handleUpdateOrder = () => {
    const errors = []
    const filteredValuesxx = values.beltLabel.map((label) => {
      if(!label.colorCode || !label.referanceCode)
      {
        errors.push("Renk Kodu ve Referans Kodu Girilmek Zorunda")
      }
      return label
    })

  
    const filteredValues = values.washingLabel.map(label => {
      const filteredFabric = label.fabric.map(fabricItem => {
        const filteredMix = fabricItem.mix.filter(mix => mix.percent > 0);
        return { ...fabricItem, mix: filteredMix };
      });
      return { ...label, fabric: filteredFabric };
    });
    if(errors.length > 0) {
      toast.error(errors.join('\n'))
      return; // İşlemi durdurur
    }
    delete values.brandId;
    if(errors.length === 0)
    {
      updateOrder({ id: orderNo, body: { ...values, washingLabel: filteredValues, brand: brandId } });
    }
  };

  const ClearableSelect = ({ value, onChange, options, placeholder, form, name }) => {
    const handleClear = () => {
      form.setFieldsValue({ [name]: undefined });
      onChange(undefined);
    };

    return (
      <div style={{ position: "relative" }}>
        <Select
          showSearch
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          style={{ width: '100%' }}
          filterOption={(input, option) => option?.children?.toLowerCase().includes(input.toLowerCase())}
          suffixIcon={<span style={{ display: 'none' }}></span>}
        >
          {options.map(option => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
        {value && (
          <RxCross1
            onClick={handleClear}
            style={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "red",
            }}
          />
        )}
      </div>
    );
  };

  return (
    <FieldArray name="beltLabel">
      {({ push, remove }) => {
        // PriceInstructions'daki gibi - sadece beltLabel boşsa ve henüz initialize edilmediyse bir kez ekle
        if (!hasInitializedBeltLabel.current && (!values.beltLabel || values.beltLabel.length === 0) && push) {
          hasInitializedBeltLabel.current = true;
          push({
            customerOrderNo: '',
            customerOrderDetail: '',
            colorCode: '',
            referanceCode: '',
            sizes: []
          });
        }

        return (
          <div>
            {values.beltLabel.map((_, idx) => {
              return (
              <div className="grid grid-cols-2 gap-5 pb-5 relative" key={idx}>
                <div className="col-span-2 grid grid-cols-2 gap-2 rounded border border-dashed p-2">
                  <UIInput
                    label="Müşteri Sipariş No"
                    value={values.beltLabel[idx]?.customerOrderNo}
                    onChange={(e) => {
                      setFieldValue(`beltLabel[${idx}].customerOrderNo`, e.target.value);
                    }}
                  />
                  <FormikInput
                    label="Müşteri Sipariş Detayı"
                    name={`beltLabel[${idx}].customerOrderDetail`}
                    autoComplete="off"
                  />
                  <FormikInput
                    label="Renk Kodu"
                    name={`beltLabel[${idx}].colorCode`}
                    maxLength="3"
                    autoComplete="off"
                  />
          <DisliSayisiDetayModal
                  visible={isDisliModalVisible}
                  onCancel={handleDisliModalClose}
                  minWidth={'30%'} // modalType 4 ise minWidth 40%, aksi halde 30%
                  width={740}
                  title="Kemer Etiketi Referans Ekle"
                >
                  <DrawerContent4 />
                </DisliSayisiDetayModal>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                    <div style={{ width: '60%' }}>
                      {brannd === 'ZaraHome' ? (
                        <SelectReferanceCode4Home name={`beltLabel[${idx}].referanceCode`} other={valcx} />
                      ) : (
                        <SelectReferanceCode4 name={`beltLabel[${idx}].referanceCode`} other={valcx} />
                      )}
                    </div>
                    {user.companyName === "Şimşek Ege Etiket ve Matbaacılık\nLimited Şirketi" && 
                      user.tierType === "ADMIN" && (
  <div style={{ width: '20%', overflow:'hidden', marginRight:0}}>
    <UIButton
      type="button"
      variant="blue"
      onClick={handleDisliModalOpen}
      style={{width:'100%'}}
    >
      Referans Ekle
    </UIButton>
  </div>
)}
                    <div style={{ width: '20%' }}>

                    {(values.washingLabel?.some(label => label?.sizes?.length > 0) || 
    values.priceLabel?.some(label => label?.sizes?.length > 0) || 
    values.brandLabel?.some(label => label?.sizes?.length > 0)) && (
      <UIButton
  type="button"
  style={{backgroundColor:'#b0059c'}}
  onClick={() => {
    const availableLabels = [];
    
    // Her kaynak tipindeki her colorCode için ayrı seçenek oluştur
    if (values.washingLabel?.some(label => label?.sizes?.length > 0)) {
      const washingLabels = values.washingLabel.filter(label => label?.sizes?.length > 0);
      washingLabels.forEach((label, idx) => {
        availableLabels.push({
          type: 'washing',
          label: label,
          name: washingLabels.length > 1 ? `Yıkama Talimatı - ${label.colorCode || `Renk ${idx + 1}`}` : 'Yıkama Talimatı',
          colorCode: label.colorCode || ''
        });
      });
    }
    
    if (values.priceLabel?.some(label => label?.sizes?.length > 0)) {
      const priceLabels = values.priceLabel.filter(label => label?.sizes?.length > 0);
      priceLabels.forEach((label, idx) => {
        availableLabels.push({
          type: 'price',
          label: label,
          name: priceLabels.length > 1 ? `Fiyat Etiketi - ${label.colorCode || `Renk ${idx + 1}`}` : 'Fiyat Etiketi',
          colorCode: label.colorCode || ''
        });
      });
    }
    
    if (values.brandLabel?.some(label => label?.sizes?.length > 0)) {
      const brandLabels = values.brandLabel.filter(label => label?.sizes?.length > 0);
      brandLabels.forEach((label, idx) => {
        availableLabels.push({
          type: 'brand',
          label: label,
          name: brandLabels.length > 1 ? `Marka Kartı - ${label.colorCode || `Renk ${idx + 1}`}` : 'Marka Kartı',
          colorCode: label.colorCode || ''
        });
      });
    }

    if (availableLabels.length > 0) {
      let selectedIndex = null;

      // Tek seçenek varsa direkt kopyala
      if (availableLabels.length === 1) {
        const selectedItem = availableLabels[0];
        setFieldValue(`beltLabel[${idx}]`, {
          ...values.beltLabel[idx],
          sizeDefectivePercent: selectedItem.label.sizeDefectivePercent || '',
          sizes: selectedItem.label.sizes.map(size => ({
            ...size,
            amount: size.amount || '',
            amountWithDefect: size.amountWithDefect || ''
          }))
        });
        message.success(`${selectedItem.name}${selectedItem.colorCode ? ' - ' + selectedItem.colorCode : ''} bedenleri kopyalandı`);
      } else {
        // Birden fazla seçenek varsa modal göster
        Modal.confirm({
          title: 'Veri Kaynağını Seçin',
          content: (
            <Select 
              style={{ width: '100%' }} 
              placeholder="Kaynak seçin"
              onChange={(value) => { selectedIndex = value; }}
            >
              {availableLabels.map((item, itemIdx) => (
                <Select.Option key={itemIdx} value={itemIdx}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          ),
          onOk: () => {
            if (selectedIndex === null) {
              message.error('Lütfen bir kaynak seçin');
              return;
            }
            
            const selectedItem = availableLabels[selectedIndex];
            if (selectedItem && selectedItem.label) {
              setFieldValue(`beltLabel[${idx}]`, {
                ...values.beltLabel[idx],
                sizeDefectivePercent: selectedItem.label.sizeDefectivePercent || '',
                sizes: selectedItem.label.sizes.map(size => ({
                  ...size,
                  amount: size.amount || '',
                  amountWithDefect: size.amountWithDefect || ''
                }))
              });
              message.success(`${selectedItem.name}${selectedItem.colorCode ? ' - ' + selectedItem.colorCode : ''} bedenleri kopyalandı`);
            }
          }
        });
      }
    } else {
      message.warning('Kopyalanacak veri bulunamadı');
    }
  }}
  className="w-full"
>
  Oto Doldur
</UIButton>
  )}
  </div>

                  </div>
                </div>
                <div style={{flex:1,minWidth:1000}}>
                  {brannd === 'ZaraHome' ? (
                    <BeltSizesHome idx={idx} brannd={brannd} setdepartmantIDD={setdepartmantIDD} setifinch={setifinch} ifinch={ifinch} />
                  ) : (
                    <BeltSizes idx={idx} />
                  )}
                  <div className="col-span-2">
                    {idx > 0 && (
                      <UIButton
                        variant="destructive"
                        onClick={() => remove(idx)}
                        className="absolute -right-40 top-0"
                      >
                        <X className="w-4 h-4 text-white" /> Renk Sil
                      </UIButton>
                    )}
                  </div>
                </div>
              </div>
              );
            })}

            <div className="flex items-center gap-x-5">
              {!orderNo && (
                <UIButton
                  type="submit"
                  variant="softgreen"
                  onClick={handleSaveOrder}
                  disabled={isPending}
                  className="w-full"
                >
                  {isPending && <RotateCcw className="animate-spin mr-2" size={16} />} Kaydet
                </UIButton>
              )}

              <UIButton
                type="button"
                onClick={orderNo ? handleUpdateOrder : handleSaveOrder}
                disabled={isPending || isPendingUpdate}
                className="w-full"
                variant={orderNo ? 'softgreen' : undefined}
              >
                {(isPending || isPendingUpdate) && <RotateCcw className="animate-spin mr-2" size={16} />} {orderNo ? 'Güncelle' : "Artwork'e Git"}
              </UIButton>

              {orderNo && (
                <Link
                to={{
    pathname: `/siparisler/artwork/${orderNo}`,
    search: createSearchParams({
      tab: '3',
      zaratype: brannd ?? ''
    }).toString()
  }}
       
                  target="_blank"
                  className="w-full"
                >
                  <UIButton type="button" disabled={isPending} className="w-full">
                    {isPending && <RotateCcw className="animate-spin mr-2" size={16} />} Artwork'e Git
                  </UIButton>
                </Link>
              )}



              <Button 
                  type="button" 
                  disabled={isPending} 
                  className="w-full" 
                  style={{backgroundColor: '#f56020', color: 'white'}}
                  onClick={handleBicakIziModalOpen}
                >
                  {isPending && <RotateCcw className="animate-spin mr-2" size={16} />}
                  Bıçak İzi Hazırla
                </Button>

              <DisliSayisiDetayModal
            visible={isBicakIziModalVisible}
            onCancel={handleBicakIziModalClose}
            minWidth={'30%'}
            width={500}
            title={`Bıçak İzi Hazırla - Renk Kodu: ${values.beltLabel[0]?.colorCode || 'Belirtilmemiş'}`}
          >
            <div style={{ padding: '20px' }}>
              <h3 className="text-lg font-semibold mb-2">Beden Adetleri</h3>
              <p className="text-sm mb-4">Bıçak izi için seçtiğiniz bedenler ve adetleri belirleyin.</p>
              
              <div className="flex justify-between items-center mb-4 p-3 bg-gray-100 rounded-md border">
                <span className="font-semibold">Toplam Bıçak İzi Adedi:</span>
                <span className={`text-lg font-bold ${totalAmount === 20 ? 'text-green-600' : totalAmount > 0 ? 'text-blue-600' : 'text-gray-500'}`}>
                  {totalAmount} / 27
                </span>
              </div>
              
              {values.beltLabel[0]?.sizes.filter(size => size.amount && size.amount !== '0' && size.amount !== 0).length === 0 ? (
                <div className="p-4 bg-yellow-50 rounded-md border border-yellow-200 text-center">
                  <p className="text-yellow-600">Hiç beden seçilmemiş. Lütfen önce beden adetleri girin.</p>
                </div>
              ) : (
                <div className="border rounded-md p-4 mb-4 max-h-[300px] overflow-y-auto">
                  {values.beltLabel[0]?.sizes
                    .filter(size => size.amount && size.amount !== '0' && size.amount !== 0)
                    .map((size, idx) => (
                    <div key={idx} className="flex justify-between items-center mb-3 border-b pb-2">
                      <div className="flex flex-col">
                        <span className="text-md font-medium">{size.sizeCode}</span>
                        <span className="text-xs text-gray-500">{size.sizeName || size.name || 'Beden'}</span>
                      </div>
                      <div className="flex items-center">
                        <input
                          type="number"
                          min="0"
                          max="27"
                          value={sizeAmounts[`${size.sCode}_${size.name || 'Beden'}`] || 0}
                          onChange={(e) => handleSizeAmountChange(
                            size.sCode, 
                            size.name || 'Beden', 
                            e.target.value
                          )}
                          className="border rounded-md px-3 py-2 w-[100px] text-right"
                          onFocus={(e) => e.target.select()} // Tıklandığında mevcut değeri seç
                        />
                        <span className="ml-2">Adet</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              
              <div className="flex justify-end mt-6">
                <Link
                  to={createBicakIziUrl()}
                  className="w-full"
                  onClick={(e) => {
                    // Eğer hiç beden seçilmemişse linke gitmeyi engelle
                    if (totalAmount === 0) {
                      e.preventDefault();
                    } else {
                      // Modalı kapat
                      handleBicakIziBas();
                    }
                  }}
                >
                  <Button
                    disabled={totalAmount === 0}
                    className="w-full"
                    style={{backgroundColor: '#f56020', color: 'white'}}
                  >
                    Bıçak İzi Bas
                  </Button>
                </Link>
              </div>
            </div>
          </DisliSayisiDetayModal>
              <UIButton
                type="button"
                variant="blue"
                onClick={() => {
                  push({
                    ...values.beltLabel[0],
                    colorCode: '',
                    sizeDefectivePercent: '',
                    sizes: values.beltLabel[0]?.sizes.map(size => ({
                      ...size,
                      amount: '',
                      amountWithDefect: ''
                    }))
                  });
                }}
                className="w-full"
              >
                Renk Ekle
              </UIButton>
            </div>
          </div>
        );
      }}
    </FieldArray>
  );
}
